<template>
	<app-table
		class="is-not-selectable no-main-list"
		:columns="columns"
		:filter-columns="false"	
		:main-list="false"
		:rows="rows"
		icon-excel
		title="Lista de Regalos"
	>
		<template slot="excel">
			<app-tooltip-button
				img="https://s3.amazonaws.com/apprunn-acl/icons/iETp45XgbX9CsBuFFTr3lhd4g520sA.svg"
				text="Nuevo Regalo"
				@click-icon="goTo('new-present')"
			/>
		</template>
		<template slot="rows" slot-scope="{ row }">
			<td v-show="showRow(columns, 1)" class="is-not-selectable border-top">{{ row.name }}</td>
			<td v-show="showRow(columns, 2)" class="border-top txt-center">
				<img :src="row.icon.urlImage" alt="ícono">
			</td>
			<td v-show="showRow(columns, 3)" class="border-top">{{ row.points }}</td>
			<td v-show="showRow(columns, 4)" class="actions">
				<app-tooltip-button
					img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/new-file-1-(4).svg"
					text="Editar"
					@click-icon="updatingPresent(row)"
				/>
				<app-tooltip-button
					img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/delete-button-(1).svg"
					text="Eliminar"
					color="info"
					@click-icon="deleting(row)"
				/>
			</td>
		</template>
	</app-table>
</template>
<script>

function updatingPresent(present) {
	this.goTo('new-present');
	this.$store.dispatch('presentsConfiguration/updatePresentAction', null);
	this.$store.dispatch('icon/selectIconAction', present.icon);
	this.$store.dispatch('presentsConfiguration/updatePresentAction', present);
}

async function deleting({ id }) {
	try {
		await this.$store.dispatch('presentsConfiguration/deletePresent', id);
		this.showNotification('Regalo eliminado exitosamente', 'success');
	} catch (err) {
		this.showGenericError();
	}
}

export default {
	name: 'presents-list',
	methods: {
		deleting,
		updatingPresent,
	},
	props: {
		columns: {
			required: true,
			type: Array,
		},
		rows: {
			required: true,
			type: Array,
		},
	},
};
</script>
<style lang="scss" scoped>
.actions {
	text-align: center !important;
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/presents/presents-list.vue